import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import BlogSidebar from '../../components/blog-sidebar'
import Footer from '../../components/footer'

import bg from '../../assets/images/bg.jpg'

import { blogData } from '../../data/blog-data'

export default function BlogsSidebar() {
  return (
    <>
    <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Blog With Sidebar</h4>
                          <p className="text-muted mb-0">We present and write attractive blog posts with Sidebar</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Blog</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Blog & Sidebar</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-lg-8 col-md-6">
                  <div className="row">
                    {blogData.map((item,index)=>{
                      return(
                          <div className="col-lg-6 col-md-12 mb-4 pb-2" key={index}>
                              <div className="card blog-post rounded border-0 shadow">
                                  <div className="blog-img d-block overflow-hidden position-relative">
                                      <img src={item.image} className="img-fluid rounded-top" alt=""/>
                                      <div className="overlay rounded-top"></div>
                                      <div className="post-meta">
                                          <Link to="#" className="text-white title-dark d-block text-end like"><i className="mdi mdi-heart"></i> 33</Link>
                                          <Link to="#" className="text-white title-dark read-more">Read More <i className="mdi mdi-chevron-right"></i></Link>
                                      </div>
                                  </div>
                                  <div className="content p-3">
                                      <small className="text-muted p float-end">{item.date}</small>
                                      <small><Link to="#" className="text-primary">{item.tag}</Link></small>
                                      <h4 className="mt-2"><Link to={`/blog-standard-post/${item.id}`} className="text-dark title">{item.title}</Link></h4>
                                      <p className="text-muted mt-2">{item.desc}</p>
                                      <div className="pt-3 mt-3 border-top d-flex">
                                          <img src={item.clientImg} className="img-fluid avatar avatar-ex-sm rounded-pill me-3 shadow" alt=""/>
                                          <div className="author mt-2">
                                              <h6 className="mb-0"><Link to="#" className="text-dark name">{item.clientName}</Link></h6>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      )
                    })}

                      <div className="col-12">
                          <ul className="pagination justify-content-center mb-0 list-unstyled">
                              <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border"> Prev</Link></li>
                              <li className="active"><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">1</Link></li>
                              <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">2</Link></li>
                              <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">3</Link></li>
                              <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">4</Link></li>
                              <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">Next </Link></li>
                          </ul>
                      </div>
                  </div>
              </div>

              <div className="col-lg-4 col-md-6">
                  <BlogSidebar/>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
